export const MuiOutlinedInput = {
  input: { padding: "1.1rem", fontSize: "1.4rem" },
}
